import React, { useEffect, useState } from "react";
import { api } from "@/lib/apiClient";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Switch } from "@/components/ui/switch";
import { Plus, Trash2 } from "lucide-react";

const DAYS = ["Lundi", "Mardi", "Mercredi", "Jeudi", "Vendredi", "Samedi", "Dimanche"];

export default function HoursTab() {
  const [days, setDays] = useState([]);

  useEffect(() => {
    api.get("/hours").then((r) => {
      const map = {};
      r.data.forEach((d) => (map[d.day] = d));
      setDays(Array.from({ length: 7 }, (_, i) => map[i] || { day: i, closed: false, services: [] }));
    });
  }, []);

  const upd = (di, patch) => setDays((ds) => ds.map((d, i) => (i === di ? { ...d, ...patch } : d)));
  const addSvc = (di) => upd(di, { services: [...days[di].services, { open: "18:00", close: "22:00" }] });
  const updSvc = (di, si, patch) => upd(di, { services: days[di].services.map((s, i) => (i === si ? { ...s, ...patch } : s)) });
  const delSvc = (di, si) => upd(di, { services: days[di].services.filter((_, i) => i !== si) });

  const save = async () => {
    await api.put("/hours", { days });
    toast.success("Horaires enregistrés");
  };

  return (
    <div>
      <div className="flex justify-between items-center mb-4">
        <h2 className="font-display text-2xl font-bold">Horaires d'ouverture</h2>
        <Button onClick={save} className="rounded-none bg-brand-red hover:bg-brand-red/90" data-testid="save-hours-btn">Enregistrer</Button>
      </div>
      <div className="space-y-3">
        {days.map((d, di) => (
          <div key={di} className="border border-white/15 p-3" data-testid={`day-${di}`}>
            <div className="flex items-center justify-between">
              <span className="font-medium w-28">{DAYS[di]}</span>
              <label className="flex items-center gap-2 text-sm"><Switch checked={!d.closed} onCheckedChange={(v) => upd(di, { closed: !v })} />{d.closed ? "Fermé" : "Ouvert"}</label>
            </div>
            {!d.closed && (
              <div className="mt-3 space-y-2">
                {d.services.map((s, si) => (
                  <div key={si} className="flex items-center gap-2">
                    <Input type="time" value={s.open} onChange={(e) => updSvc(di, si, { open: e.target.value })} className="rounded-none bg-neutral-800 border-white/20 w-32" />
                    <span>→</span>
                    <Input type="time" value={s.close} onChange={(e) => updSvc(di, si, { close: e.target.value })} className="rounded-none bg-neutral-800 border-white/20 w-32" />
                    <button onClick={() => delSvc(di, si)} className="text-red-400"><Trash2 className="w-4 h-4" /></button>
                  </div>
                ))}
                <Button onClick={() => addSvc(di)} variant="outline" className="rounded-none border-white/20 bg-transparent h-8 text-xs"><Plus className="w-3 h-3 mr-1" />Service (midi/soir)</Button>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
